import { render, staticRenderFns } from "./SaleDocuments.vue?vue&type=template&id=0f8953e8&scoped=true&"
import script from "./SaleDocuments.vue?vue&type=script&lang=js&"
export * from "./SaleDocuments.vue?vue&type=script&lang=js&"
import style0 from "./SaleDocuments.vue?vue&type=style&index=0&id=0f8953e8&scoped=true&lang=css&"
import style1 from "./SaleDocuments.vue?vue&type=style&index=1&scopped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8953e8",
  null
  
)

export default component.exports